export default function ({ query, store }) {
  // Check if the query parameter 'source' is present and its value is 'app'
  if (query.source) {
    store.dispatch('common/setSourceApp', query.source === 'app' || false);
  }
}
